

const filterElements = category => {
  console.log("Filtering");
  // Set all buttons as inactive
  document.querySelectorAll('.filter-button').forEach(button => button.classList.remove('active'));

  // Set the clicked button as active
  const activeButton = document.querySelector(`.filter-button.${category}`);
  activeButton.classList.add('active');

  // Hide all elements
  const hiddenEvents = document.querySelectorAll('.event').forEach(element => element.classList.add('hidden'));
  console.log('file: calendar.js:15 | filterElements | hiddenEvents:', hiddenEvents)

  // Show elements matching the clicked category
  const showEvents = document.querySelectorAll(`.event.${category}`)
  showEvents.forEach(element => element.classList.remove('hidden'));
  console.log('file: calendar.js:20 | filterElements | showEvents:', showEvents)
};


(() => {
  const categoryButtons = document.querySelectorAll(".filter-button");

  categoryButtons.forEach(button => {
    button.addEventListener('click', () => filterElements(button.textContent.trim()));
  });



})();